module.exports = __webpack_public_path__ + "static/media/graduation.3e493661.svg";